import React, { ReactNode } from 'react';

interface InvestisseurLayoutProps {
  children: ReactNode;  // Explicitly define children as a prop
}

const InvestisseurLayout: React.FC<InvestisseurLayoutProps> = ({ children }) => {
  return <>{children}</>;
};

export default InvestisseurLayout;
